import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7c5a56b6")

import {computed} from 'vue';
import {Bar} from "vue-chartjs";
import {chartColors} from "@/Constants";
import {BarElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, Title, Tooltip} from "chart.js";
    
export default _defineComponent({
  props: {
        datasets: {type: Array<any>},
        labels: {type: Array<any>},
        id: {type: String},
    },
  setup(__props) {

const props = __props


    ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale);
    const colors = Object.values(chartColors);
    const chartData = computed(() => ({
        labels: props.labels,
        datasets: props.datasets.map((dataset: any, index) => (
        { ...dataset, backgroundColor: colors[index]}
    ))
    }))
    const chartOptions = {
        responsive: true,
        plugins: {
            legend: {
                display: false
            },
        }
    }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Bar), {
    id: __props.id,
    options: chartOptions,
    data: _unref(chartData)
  }, null, 8, ["id", "data"]))
}
}

})